































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { FileLoadHistory, FileLoadHistoryResource } from '@/api/fileloadhistory';

@Component({
  computed: mapState(['fiId']),
})
export default class FileLoadHistoryTable extends Vue {
    fiId!: string;

    headers: DataTableHeader[] = [
      { text: 'CIF Count', value: 'accountHolderCount' },
      { text: 'Rel Count', value: 'accountToAccountHolderCount' },
      { text: 'Account Count', value: 'accountCount' },
      { text: '# Trx Loaded', value: 'transactionLoadedCount' },
      { text: 'Processing Date', value: 'processingDate' },
      { text: 'Load Date', value: 'loadDateTime' },
      { text: 'Job Execution Id', value: 'jobExecutionId' },
    ];

    loading: boolean = false;

    fileLoadHistoryResults: FileLoadHistory[] = [];

    totalItems: number = 0;

    @Inject('FileLoadHistoryResource')
    fileLoadHistoryResource!: FileLoadHistoryResource;

    @Watch('fiId')
    onFiChange() {
      this.fileLoadHistoryResults = [];
      this.getFileLoadHistory();
    }

    showErrorMessage(error: string) {
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }

    mounted() {
      this.getFileLoadHistory();
    }

    getFileLoadHistory() {
      this.loading = true;
      this.totalItems = 0;

      this.fileLoadHistoryResource.getFileLoadHistory(this.fiId)
        .then((result: any) => {
          this.fileLoadHistoryResults = result;
          this.totalItems = result.length;
        }).catch((error: any) => {
          this.handleError(error);
        }).finally(() => {
          this.loading = false;
        });
    }

    handleError(error: any) {
      if (error.response.status !== 401) {
        if (error.response.status === 504) {
          this.showErrorMessage('The request timed out.');
        } else {
          this.showErrorMessage('An unexpected error occurred while attempting to perform the request.');
        }
      }
    }

    formatDateTime = (date: Date) => {
      if (date !== null) {
        const dateFormatOptions = {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        };
        return new Date(date).toLocaleDateString('en-US', dateFormatOptions).replace(',', '');
      }
      return '';
    }
}
